import { makeStyles } from "@fluentui/react-components";

export const useStyles = makeStyles({
  flexColumnStyle: {
    display: "flex",
    flexDirection: "column",
  },
  fullWidth: {
    width: "100%",
  },
  authContainer: {
    minWidth: "350px",
    maxWidth: "450px",
    border: "0px",
    rowGap: "15px",
  },
});
